"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const styles_1 = __importDefault(require("./styles"));
const react_1 = __importDefault(require("react"));
const Checked_1 = __importDefault(require("./Checked"));
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const CustomCheckBox = (props) => {
    const [value, setValue] = react_1.default.useState(props.checked /*default value*/);
    const handleClick = () => {
        const newValue = !value; //switch value
        setValue(newValue);
        if (props.onChange)
            props.onChange();
    };
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.checkboxContainer, props.styles] },
        react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 0.7, onPress: handleClick, style: { flexDirection: 'row', alignItems: 'center' } },
            !!value ?
                react_1.default.createElement(react_native_1.View, { style: {
                        height: (0, scale_1.scale)(21),
                        width: (0, scale_1.scale)(20),
                        borderRadius: (0, scale_1.scale)(4),
                        backgroundColor: "#007AFF",
                        overflow: 'hidden'
                    } },
                    react_1.default.createElement(Checked_1.default, null))
                :
                    react_1.default.createElement(react_native_1.View, { style: {
                            height: (0, scale_1.scale)(21),
                            width: (0, scale_1.scale)(20),
                            borderRadius: (0, scale_1.scale)(4),
                            borderColor: "#707070",
                            borderWidth: 1
                        } }),
            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.checkboxLabel }, props.label))));
};
exports.default = CustomCheckBox;
